import React, { useEffect, useState } from "react";
import { urls, icons } from "../../../constant";
import { useSelector, useDispatch } from "react-redux";
import { FaSync } from "react-icons/fa";
import {
  setError,
  setLoading,
  setIsSaved,
  setOpenModal,
  setData,
  setDropValue,
  setIsWaitingData,
} from "../../../global-state/redux";
import { getRequest, postRequest } from "../../../network/httpRequest";
import { formatterDateAndHour } from "../../../helpers";
import { TedEmpty, TedDropdown, TedCheckBox } from "../../../core-ui";
import { PaginationItems, Skelton } from "../../../components";
const configHeaderTable = [
  "#",
  "Date",
  "UMVA ID",
  "Nom & Prénom",
  "UMVA Card",
  "Uban",
  "Adresse",
  "Article",
  "Qte",
  "Status",
  "Action",
];

const ListCommandes = ({ data, tabIndex, setHasValidatedOrders, setValidatedOrderIds, setValidatedOrdersData }) => {
  const [dataCommande, setDataCommande] = useState({ count: 0, rows: [] });
  const [syncingOrders, setSyncingOrders] = useState({});
  const [showSyncDialog, setShowSyncDialog] = useState(false);
  const [syncDialogData, setSyncDialogData] = useState(null);
  const {
    dataUser: {
      user: {
        auth: { roleId },
      },
    },
  } = useSelector((store) => store.user);
  const { isSaved, isloading, isWaitingData } = useSelector(
    (store) => store.loading
  );
  const { data: commandes } = useSelector((store) => store.data);
  const dispatch = useDispatch();
  
  const getCommandes = async (page = 1) => {
    dispatch(setIsWaitingData());
    const { err, msg, data, typeErr } = await getRequest(
      `${urls.commande}?lang=fr&page=${page}&${tabIndex.clause}`
    );

    if (err) {
      dispatch(setError({ err, msg, data, typeErr }));
      return dispatch(setIsWaitingData());
    }
    dispatch(setIsWaitingData());
    setDataCommande(data);
    
    // Check if there are any validated orders and update parent component
    if (setHasValidatedOrders) {
      const hasValidated = data.rows.some(order => order.status.id === 3 && !order.isSynced);
      setHasValidatedOrders(hasValidated);
    }

    // Extract all validated order IDs for mass sync
    if (setValidatedOrderIds) {
      const validatedIds = data.rows
        .filter(order => order.status.id === 3 && !order.isSynced)
        .map(order => ({ idcommande: order.id }));
      setValidatedOrderIds(validatedIds);
    }

    // Pass full validated orders data for amount calculation
    if (setValidatedOrdersData) {
      const validatedOrders = data.rows.filter(order => order.status.id === 3 && !order.isSynced);
      setValidatedOrdersData(validatedOrders);
    }
  };

  const calculateTotals = (order) => {
    const quantity = parseFloat(order.qte || 0);
    const amount = quantity * parseFloat(order.prixUnitaire || 0);
    return { quantity, amount };
  };

  const handleIndividualSync = async (order) => {
    const { quantity, amount } = calculateTotals(order);

    // Show confirmation dialog
    setSyncDialogData({
      orderId: order.id,
      orderInfo: `${order.first_name} ${order.last_name}`,
      quantity,
      amount,
    });
    setShowSyncDialog(true);
  };

  const confirmIndividualSync = async () => {
    setShowSyncDialog(false);
    const orderId = syncDialogData.orderId;

    // Set loading state for this specific order
    setSyncingOrders(prev => ({ ...prev, [orderId]: true }));

    const { err, msg, data, typeErr } = await postRequest(
      `${urls.commande}/sync-amount-single`,
      "json",
      { idcommande: orderId }
    );

    if (err) {
      // Clear loading state for this order on error
      setSyncingOrders(prev => ({ ...prev, [orderId]: false }));
      return dispatch(setError({ err, msg, data, typeErr }));
    }

    // Clear loading state for this order
    setSyncingOrders(prev => ({ ...prev, [orderId]: false }));

    // Refresh the list to update the UI with new sync status
    dispatch(setIsSaved());
  };

  const cancelSync = () => {
    setShowSyncDialog(false);
    setSyncDialogData(null);
  };

  useEffect(() => {
    getCommandes();
    dispatch(setData([]));
  }, [isSaved, tabIndex]);

  const configdropDown = [
    {
      name: "Détails",
      icons: icons.action_details,
      fx: (item) =>
        dispatch(
          setOpenModal({
            actionName: "actionContent",
            data: item,
            actionTitle: `DETAILS DE LA COMMANDE DE ${item?.first_name} ${item?.last_name}`,
            number: 3,
          })
        ),
    },
    {
      name: "Supprimer",
      icons: icons.action_delete,
      fx: (item) =>
        dispatch(
          setOpenModal({
            actionName: "deleteContent",
            data: item,
            actionTitle: `suppression de la commande du client ${item.first_name} ${item.last_name}`,
            number: 3,
          })
        ),
    },
  ];
  const configdropDownVendeur = [
    {
      name: "Détails",
      icons: icons.action_details,
      fx: (item) =>
        dispatch(
          setOpenModal({
            actionName: "actionContent",
            data: item,
            actionTitle: `DETAILS DE LA COMMANDE DE ${item?.first_name} ${item?.last_name}`,
            number: 3,
          })
        ),
    },
  ];

  const buildDataAffectation = (idcommande) => {
    let oldCommandes = commandes;
    let newCommandes = [];
    if (oldCommandes.length < 1) {
      newCommandes = [
        {
          idcommande,
        },
      ];
    } else {
      const checkIfCommandeExist = oldCommandes.filter(
        (item) => item.idcommande === idcommande
      );
      if (checkIfCommandeExist.length > 0) {
        newCommandes = oldCommandes.filter(
          (item) => item.idcommande !== idcommande
        );
      } else {
        newCommandes = [
          ...oldCommandes,
          {
            idcommande,
          },
        ];
      }
    }
    dispatch(setData(newCommandes));
  };

  const RowSyncButton = ({ order, isLoading }) => {
    return (
      <button
        className="btn-icon-sync"
        onClick={() => handleIndividualSync(order)}
        disabled={isLoading}
        title="Synchroniser"
        style={{
          background: "transparent",
          border: "none",
          cursor: isLoading ? "not-allowed" : "pointer",
          padding: "5px",
          marginRight: "5px",
        }}
      >
        <FaSync
          color={isLoading ? "#9ca3af" : "#0369a1"}
          size={15}
          className={isLoading ? "fa-spin" : ""}
        />
      </button>
    );
  };

  const IndividualSyncDialog = ({ data, onConfirm, onCancel }) => {
    if (!data) return null;

    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'BIF',
        minimumFractionDigits: 0,
      }).format(amount);
    };

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "24px",
            maxWidth: "500px",
            width: "90%",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h3 style={{ marginTop: 0, marginBottom: "16px", color: "#0369a1" }}>
            Confirmation de Synchronisation
          </h3>
          <div style={{ marginBottom: "20px" }}>
            <p style={{ margin: "8px 0", fontSize: "14px" }}>
              <strong>Client:</strong> {data.orderInfo}
            </p>
            <p style={{ margin: "8px 0", fontSize: "14px" }}>
              <strong>Quantité:</strong> {data.quantity.toFixed(2)}
            </p>
            <p style={{ margin: "8px 0", fontSize: "14px" }}>
              <strong>Montant:</strong> {formatCurrency(data.amount)}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "flex-end",
            }}
          >
            <button
              onClick={onCancel}
              style={{
                padding: "8px 16px",
                borderRadius: "4px",
                border: "1px solid #d1d5db",
                backgroundColor: "white",
                color: "#374151",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Annuler
            </button>
            <button
              onClick={onConfirm}
              style={{
                padding: "8px 16px",
                borderRadius: "4px",
                border: "none",
                backgroundColor: "#0369a1",
                color: "white",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Confirmer
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div>

        <table className="table-normal">
          <thead>
            <tr>
              {configHeaderTable.map((i, idx) => {
                return <td key={idx}>{i}</td>;
              })}
            </tr>
          </thead>
          {!isWaitingData && (
            <tbody>
              {dataCommande &&
                dataCommande.rows.map((item) => {
                  const {
                    id,
                    umva_id,
                    first_name,
                    last_name,
                    umva_cardid,
                    uban,
                    has_umva,
                    province,
                    commune,
                    zone,
                    colline,
                    localite,
                    group,
                    commande_articles,
                    qte,
                    status,
                    vendeur_data,
                    createdAt,
                    date,
                    isSynced,
                    syncedAt,
                  } = item;
                  return (
                    <tr key={id}>
                      <td>
                        <TedCheckBox
                          name={id}
                          label=""
                          fxOnchange={(e) =>
                            buildDataAffectation(e.target.name)
                          }
                          desabled={
                            // Disable if already synced
                            isSynced
                              ? true
                              : // For admin (roleId = 1): 
                                // - Allow EN ATTENTE (id=1) for affectation
                                // - Allow VALIDER (id=3) for sync
                                // - Disable AFFECTE (id=2) and ANNULER (id=4)
                                roleId == 1 && status.id !== 1 && status.id !== 3
                              ? true
                              : // For vendor (roleId = 2):
                                // - Allow AFFECTE (id=2) for validation
                                // - Disable others
                                roleId == 2 && status.id !== 2
                              ? true
                              : false
                          }
                        />
                      </td>
                      <td>{date}</td>
                      <td>{umva_id ? umva_id : "-"}</td>
                      <td>{`${first_name} ${last_name}`}</td>
                      <td>{umva_cardid}</td>
                      <td>{uban}</td>
                      <td>{province}</td>
                      <td>
                        {commande_articles &&
                          commande_articles.translation[0]?.name}
                      </td>
                      <td>{qte}</td>
                      <td>
                        <span className={`status ${status.color}`}>
                          {status.description}
                        </span>
                      </td>
                      <td>
                        <div className="actions">
                          {status.id === 3 && !isSynced && dataCommande.rows.some(order => order.status.id === 3 && !order.isSynced) && (
                            <RowSyncButton
                              order={item}
                              isLoading={syncingOrders[id]}
                            />
                          )}
                          {status.id === 3 && isSynced && (
                            <span
                              style={{
                                color: "#047857",
                                fontSize: "12px",
                                fontWeight: "bold",
                                marginRight: "10px",
                              }}
                              title={`Synchronisé le ${new Date(syncedAt).toLocaleString('fr-FR')}`}
                            >
                              ✓ Synchronisé
                            </span>
                          )}
                          <TedDropdown
                            configdropDown={
                              roleId === 1
                                ? configdropDown
                                : configdropDownVendeur
                            }
                            data={item}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          )}
        </table>
        {isWaitingData && <Skelton n={0} />}
        {dataCommande.rows.length < 1 && !isWaitingData && (
          <TedEmpty description={"Aucune commande"} icon={icons.empty} />
        )}
      </div>
      {showSyncDialog && (
        <IndividualSyncDialog
          data={syncDialogData}
          onConfirm={confirmIndividualSync}
          onCancel={cancelSync}
        />
      )}
      <PaginationItems
        itemsPerPage={10}
        dataLength={dataCommande.count}
        changePage={getCommandes}
      />
    </>
  );
};

export default ListCommandes;
